"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LaborUnionResource = /** @class */ (function (_super) {
    tslib_1.__extends(LaborUnionResource, _super);
    function LaborUnionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LaborUnionResource.endpoint = '/laborunions';
    LaborUnionResource.MODEL_NAME = 'laborunion';
    return LaborUnionResource;
}(base_1.default));
exports.default = LaborUnionResource;
//# sourceMappingURL=laborunion.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/laborunion.js
// module id = NmtL
// module chunks = 0